import type { IPopupConfig } from "@/models";
import { defined } from "@/utils/variable-evaluation";
import { createReducer } from "@reduxjs/toolkit";
import { IPopupActions } from "./popup-actions";

export interface IPopupModel {
  popups: IPopupConfig[];
}

const INITIAL_STATE: IPopupModel = {
  popups: [],
};

/** Reducer */
export const popupReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(IPopupActions.pushPopup, (state, action): IPopupModel => {
      const popup: IPopupConfig = action.payload;
      const isAlreadyInTheList =
        defined(popup.id) &&
        state.popups.findIndex((p) => p.id === popup.id) !== -1;
      if (isAlreadyInTheList) {
        return state;
      }
      return {
        ...state,
        popups: [...state.popups, action.payload],
      };
    })
    .addCase(IPopupActions.popPopup, (state, action): IPopupModel => {
      const id: string | null | undefined = action.payload;
      let newPopups = [...state.popups];
      if (defined(id)) {
        newPopups = newPopups.filter((p) => defined(p.id) && p.id !== id);
      } else {
        // if no id then just remove the last one added
        newPopups = newPopups.filter((p, i, { length }) => i !== length - 1);
      }
      return {
        ...state,
        popups: newPopups,
      };
    });
});
